export default "__VITE_ASSET__B$WHkwrI__"